module.exports = __webpack_public_path__ + "img/2374fda.jpg";